import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import { ICompanyViewModel } from 'Interfaces/ICompaniesConfig';
import { TextStyle } from 'data/FontStyle';
import useWindowsDimension from 'functions/useWindowsDimension';
import { rq } from 'http/apiRoutes';
import { useGet } from 'http/useApi';
import React, { useEffect, useRef, useState } from 'react';
import { CompaniesList } from '../../../pages/Companies/CompaniesList';
import { boolean } from 'yup';
import { EnumCompanyType } from 'Interfaces/IGlobalTypeConfig';

type CompaniesDrawerProps = {
  buttonIcon: React.ReactNode | null; // or 'any' if you prefer
  buttonContext: string; // or 'any', but string is typically used
  handleChange: (
    event: React.MouseEvent<HTMLElement>,
    company: ICompanyViewModel
  ) => void;
  isHideCompanyView?: boolean;
  isHideCompanyNavigation?: boolean;
  companyType?: EnumCompanyType;
};

export const CompaniesDrawer = ({
  buttonIcon,
  buttonContext,
  handleChange,
  isHideCompanyView,
  isHideCompanyNavigation,
  companyType,
}: CompaniesDrawerProps) => {
  const { width } = useWindowsDimension();
  const [open, setOpen] = useState(false);
  const [companies, setCompanies] = useState([]);

  const ref = useRef<EnumCompanyType>(companyType ?? EnumCompanyType.CLIENT);
  /* const { data: companiesData } = useGet(
    rq.companies(ref.current.toFixed(0), true)
  ); */

  console.log('is.  HideCompanyView', isHideCompanyView);
  console.log('is.  HideCompanyNavigation', isHideCompanyNavigation);

  const handleLocalChange = (
    e: React.MouseEvent<HTMLElement>,
    company: ICompanyViewModel
  ) => {
    // 1) Call the "external" handleChange that you received as a prop
    handleChange(e, company);

    // 2) Close the drawer
    setOpen(false);
  };

  /*   useEffect(() => {
    if (companiesData) {
      //console.log('data', data);
      setCompanies(companiesData.companies);
    }
  }, [companiesData]); */
  let buttonWidth = buttonIcon === null ? '100%' : 32;
  let buttonHeight = buttonIcon === null ? 64 : 32;
  return (
    <>
      {buttonIcon === null ? (
        <Button
          variant='contained'
          sx={{
            borderRadius: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            width: buttonWidth || '100%',
            height: buttonHeight || '100%',
          }}
          onClick={() => setOpen(!open)}
        >
          <Typography
            sx={{
              textTransform: 'uppercase',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 'bold',
              fontSize: 14,
              letterSpacing: 2,
              color: 'primary.text',
            }}
          >
            {buttonContext}
          </Typography>
        </Button>
      ) : (
        <Box
          sx={[
            TextStyle.buttonBox,
            {
              width: buttonWidth || 32,
              height: buttonHeight || 32,
            },
          ]}
        >
          <IconButton
            sx={{
              p: 0,
              m: 0,
              width: buttonWidth || 18,
              height: buttonHeight || 18,
            }}
            onClick={() => setOpen(!open)}
          >
            {buttonIcon}
          </IconButton>
        </Box>
      )}

      <Drawer anchor={'left'} open={open} onClose={() => setOpen(!open)}>
        <Box sx={{ width: width / 2, backgroundColor: 'primary.main' }}>
          <CompaniesList
            handleChange={handleLocalChange}
            isHideCompanyView={isHideCompanyView}
            isHideCompanyNavigation={isHideCompanyNavigation}
            companyType={ref.current}
            // companies={companies}
            //   setOpen={setOpen}
            //   handleEmployeeSubmit={handleEmployeeSubmit}
            //   handleRemoveEmployeeSubmit={handleRemoveEmployeeSubmit}
          />
        </Box>
      </Drawer>
    </>
  );
};
